/**
 * Returns an optimized Cloudinary URL with:
 * - Automatic format selection (WebP/AVIF based on browser support)
 * - Intelligent quality compression
 * - Optional width/height cropping
 *
 * @param {string} url - Original Cloudinary URL
 * @param {object} options - { width, height, quality, format }
 * @returns {string} Optimized URL
 */
export function getOptimizedImage(url, options = {}) {
  if (!url || !url.includes('cloudinary')) return url;

  const {
    width,
    height,
    quality = 'auto',
    format = 'auto',
  } = options;

  // Cloudinary transformation string
  const transformations = [];

  if (width) transformations.push(`w_${width}`);
  if (height) transformations.push(`h_${height}`);
  if (width || height) transformations.push('c_fill');   // crop to fill dimensions
  transformations.push(`q_${quality}`);
  transformations.push(`f_${format}`);   // auto → WebP/AVIF

  const transformString = transformations.join(',');

  // Inject transformation after 'upload/' in the URL
  // e.g., .../upload/v1234567890/image.jpg → .../upload/v1234567890/w_400,h_400,c_fill,q_auto,f_auto/image.jpg
  return url.replace('/upload/', `/upload/${transformString}/`);
}